import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { renderCheckBox, renderTextField } from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import { saveSecurityQuestion, getSecurityQuestionById } from '../actions/SecurityQuestionActions';
import validate from '../validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../modules/AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import { displayCustomError } from '../../../../../../src/actions/utilAction';
import SmallLoader from '../../../../../img/small-loader.gif';

class SecurityQuestionModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      securityQuestionId: props.securityQuestionId,
    };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };
  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }
  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {

      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.id) ? this.props.initialValues.id : 0,
      };
      // console.log('input.postData...........',postData)
      this.props.checkFieldExistence(postData);
    }
  };
  componentWillMount() {
    if (this.props.securityQuestionId) {
      this.props.getSecurityQuestionById(this.props.securityQuestionId);
    }
  }
  onSubmitHandler(formData) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formData.question = formData.question.trim();
    formData.isActive = formData.isActive ? true : false;
    formData.value = undefined;
    // console.log('formData.........inner.......',formData)
    this.props.clearFieldErrorArray();
    this.props.saveSecurityQuestion(formData);
    this.setState({ open: false });
    this.props.closeDialog();
  }
  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }
  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Saving" /> :
      this.props.fieldErrorLoading ? <SubmitButtonModalDisabled label="Save" /> : <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.props.securityQuestionId ? 'Edit Security Question' : 'Add Security Question'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="question"
                    type="text"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Question')}
                    customError={displayCustomError('QUESTION', this.props.fieldError)}
                    maxLength="50"
                    label="Question"
                    component={renderTextField} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <Field className="mt20 mb0"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div>
              {/* <div className="row">
                <div className="col-sm-12 pt20 btn_rt">
                  <FlatButton className="grey_btn"
                    label="Cancel"
                    onTouchTap={this.handleClose}
                  />
                  <FlatButton className="blue_btn"
                    label="Submit"
                    primary={true}
                    type='submit'
                  />
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}
function mapStateToProps(state, ownProps) {
  // console.log('ownProps.securityQuestionData: ', ownProps.securityQuestionData);
  let initialValueData = null;
  if (ownProps.securityQuestionId && state.mastersecurityQuestions.getSecurityQuestionById && state.mastersecurityQuestions.getSecurityQuestionById.data) {
    initialValueData = state.mastersecurityQuestions.getSecurityQuestionById.data;
  }
  return {
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
    loading: state.mastersecurityQuestions.loading,
  };
}

SecurityQuestionModal = reduxForm({
  form: 'SecurityQuestionModalForm',
  validate,
  enableReinitialize: true,
})(SecurityQuestionModal);

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveSecurityQuestion, getSecurityQuestionById })(SecurityQuestionModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/securityQuestions/components/security-question-modal.js